export default __webpack_public_path__ + "media/flags/sm-83fe677c.svg";